import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class StorageService {

  constructor() {}

  // Store the value
  store(storageKey: string, value: any) {
      localStorage.setItem(
          storageKey,
          value
      );
  }
  
  // Get the value
  get(storageKey: string) : string | null{
      return localStorage.getItem(storageKey);
  }
  
  removeStorageItem(storageKey: string) {
      localStorage.removeItem(storageKey);
  }
  
  // Clear storage
  clear() {
      
      localStorage.clear();
  }
}
